var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXTwitterDarkTheme = function SvgXTwitterDarkTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 1.77h2.249L9.552 7.385l5.78 7.642h-4.525l-3.545-4.635-4.056 4.635H.956L6.21 9.02.666 1.77h4.64l3.205 4.236 3.706-4.236Zm-.79 11.91h1.247L4.63 3.046H3.292l8.136 10.636Z",
    fill: "#fff"
  })));
};
export default SvgXTwitterDarkTheme;